import {
    REQUEST_LANG,
    RECEIVE_LANG_DATA,
    CLEAR_LANG_DATA,
  } from "../constants/Lookup";
  
  export const requestLangData = () => {
    return {
      type: REQUEST_LANG,
    };
  };
  
  export const receiveLangData = (data) => {
    return {
      type: RECEIVE_LANG_DATA,
      data,
    };
  };
  export const clearLangData = () => {
    return {
      type: CLEAR_LANG_DATA,
    };
  };
  